import { ColumnDef } from '@tanstack/react-table';

import {
  EmissionSourceFactorUnitType,
  EmissionSourceGreenHouseGases,
  EmissionSourceSubCategory,
} from '@/app/org-cfv/src/enums/EmissionSourceEnum';
import { Approval } from '@/app/org-cfv/src/typings/ActivityDataDetailsTypings';
import { EmissionsType } from '@/app/org-cfv/src/typings/CreateActivityDataTypings';

import { ActivityUnit } from '../../src/enums/ActivityDataTypeEnum';

export enum ActivityDataType {
  ENTRY = 'entry',
  APPROVAL = 'approval',
  COLLECTION = 'collection',
}

export enum OrgCFVRoute {
  ENTRY = 'activity-data-entry',
  APPROVAL = 'activity-data-approval',
  COLLECTION = 'data-collection',
}

export type SubCategoriesHeader = {
  [key in EmissionSourceSubCategory]?: ColumnDef<Approval & EmissionsType>[];
};

export type HeaderTitle = {
  [key in OrgCFVRoute]?: SubCategoriesHeader;
};

export type ExcludeNaEmissionSourceGreenHouseGases = Exclude<
  EmissionSourceGreenHouseGases,
  EmissionSourceGreenHouseGases.NA
>;

export type SettingFactorType = Record<
  ExcludeNaEmissionSourceGreenHouseGases,
  { factor: number; ghgUnit: ActivityUnit; factorUnitType: EmissionSourceFactorUnitType; factorUnit: ActivityUnit }
>;
